/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  AccountVerificationResponse,
  AccountVerificationThrottled,
  AggregateResult,
  Car,
  CarComplianceDocument,
  CarForm,
  CarHistoryEvent,
  CarInProperty,
  CarRequest,
  CarViolationsResponse,
  CertificateBasic,
  CheckPermissionRequest,
  CheckPermissionResponse,
  PatchedCarRequest,
  SpendingNotificationRequest,
  UserDetail,
  UsersCarsAggregateRetrieveParams,
  UsersCarsCertificatesListParams,
  UsersCarsComplianceDocumentsListParams,
  UsersCarsFormListParams,
  UsersCarsHistoryListParams,
  UsersCarsKpisByPropertyIdListParams,
  UsersCarsListParams,
  UsersSendSpendingNotificationCreate200
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type usersRetrieveResponse200 = {
  data: UserDetail
  status: 200
}

export type usersRetrieveResponseSuccess = (usersRetrieveResponse200) & {
  headers: Headers;
};
;

export type usersRetrieveResponse = (usersRetrieveResponseSuccess)

export const getUsersRetrieveUrl = (email: string,) => {




  return `/api/v1/users/${email}/`
}

export const usersRetrieve = async (email: string, options?: RequestInit): Promise<usersRetrieveResponse> => {

  return customFetch<usersRetrieveResponse>(getUsersRetrieveUrl(email),
  {
    ...options,
    method: 'GET'


  }
);}


export type usersPermissionsRetrieveResponse200 = {
  data: UserDetail
  status: 200
}

export type usersPermissionsRetrieveResponseSuccess = (usersPermissionsRetrieveResponse200) & {
  headers: Headers;
};
;

export type usersPermissionsRetrieveResponse = (usersPermissionsRetrieveResponseSuccess)

export const getUsersPermissionsRetrieveUrl = (email: string,) => {




  return `/api/v1/users/${email}/permissions/`
}

export const usersPermissionsRetrieve = async (email: string, options?: RequestInit): Promise<usersPermissionsRetrieveResponse> => {

  return customFetch<usersPermissionsRetrieveResponse>(getUsersPermissionsRetrieveUrl(email),
  {
    ...options,
    method: 'GET'


  }
);}


export type usersVerifyRetrieveResponse200 = {
  data: AccountVerificationResponse
  status: 200
}

export type usersVerifyRetrieveResponse400 = {
  data: AccountVerificationResponse
  status: 400
}

export type usersVerifyRetrieveResponse429 = {
  data: AccountVerificationThrottled
  status: 429
}

export type usersVerifyRetrieveResponseSuccess = (usersVerifyRetrieveResponse200) & {
  headers: Headers;
};
export type usersVerifyRetrieveResponseError = (usersVerifyRetrieveResponse400 | usersVerifyRetrieveResponse429) & {
  headers: Headers;
};

export type usersVerifyRetrieveResponse = (usersVerifyRetrieveResponseSuccess | usersVerifyRetrieveResponseError)

export const getUsersVerifyRetrieveUrl = (email: string,) => {




  return `/api/v1/users/${email}/verify/`
}

export const usersVerifyRetrieve = async (email: string, options?: RequestInit): Promise<usersVerifyRetrieveResponse> => {

  return customFetch<usersVerifyRetrieveResponse>(getUsersVerifyRetrieveUrl(email),
  {
    ...options,
    method: 'GET'


  }
);}


export type usersCarsListResponse200 = {
  data: Car[]
  status: 200
}

export type usersCarsListResponseSuccess = (usersCarsListResponse200) & {
  headers: Headers;
};
;

export type usersCarsListResponse = (usersCarsListResponseSuccess)

export const getUsersCarsListUrl = (ownerEmail: string,
    params?: UsersCarsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/users/${ownerEmail}/cars/?${stringifiedParams}` : `/api/v1/users/${ownerEmail}/cars/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const usersCarsList = async (ownerEmail: string,
    params?: UsersCarsListParams, options?: RequestInit): Promise<usersCarsListResponse> => {

  return customFetch<usersCarsListResponse>(getUsersCarsListUrl(ownerEmail,params),
  {
    ...options,
    method: 'GET'


  }
);}


export type usersCarsCreateResponse201 = {
  data: Car
  status: 201
}

export type usersCarsCreateResponseSuccess = (usersCarsCreateResponse201) & {
  headers: Headers;
};
;

export type usersCarsCreateResponse = (usersCarsCreateResponseSuccess)

export const getUsersCarsCreateUrl = (ownerEmail: string,) => {




  return `/api/v1/users/${ownerEmail}/cars/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const usersCarsCreate = async (ownerEmail: string,
    carRequest: CarRequest, options?: RequestInit): Promise<usersCarsCreateResponse> => {

  return customFetch<usersCarsCreateResponse>(getUsersCarsCreateUrl(ownerEmail),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(carRequest)
  }
);}


export type usersCarsRetrieveResponse200 = {
  data: Car
  status: 200
}

export type usersCarsRetrieveResponseSuccess = (usersCarsRetrieveResponse200) & {
  headers: Headers;
};
;

export type usersCarsRetrieveResponse = (usersCarsRetrieveResponseSuccess)

export const getUsersCarsRetrieveUrl = (ownerEmail: string,
    id: string,) => {




  return `/api/v1/users/${ownerEmail}/cars/${id}/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const usersCarsRetrieve = async (ownerEmail: string,
    id: string, options?: RequestInit): Promise<usersCarsRetrieveResponse> => {

  return customFetch<usersCarsRetrieveResponse>(getUsersCarsRetrieveUrl(ownerEmail,id),
  {
    ...options,
    method: 'GET'


  }
);}


export type usersCarsUpdateResponse200 = {
  data: Car
  status: 200
}

export type usersCarsUpdateResponseSuccess = (usersCarsUpdateResponse200) & {
  headers: Headers;
};
;

export type usersCarsUpdateResponse = (usersCarsUpdateResponseSuccess)

export const getUsersCarsUpdateUrl = (ownerEmail: string,
    id: string,) => {




  return `/api/v1/users/${ownerEmail}/cars/${id}/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const usersCarsUpdate = async (ownerEmail: string,
    id: string,
    carRequest: CarRequest, options?: RequestInit): Promise<usersCarsUpdateResponse> => {

  return customFetch<usersCarsUpdateResponse>(getUsersCarsUpdateUrl(ownerEmail,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(carRequest)
  }
);}


export type usersCarsPartialUpdateResponse200 = {
  data: Car
  status: 200
}

export type usersCarsPartialUpdateResponseSuccess = (usersCarsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type usersCarsPartialUpdateResponse = (usersCarsPartialUpdateResponseSuccess)

export const getUsersCarsPartialUpdateUrl = (ownerEmail: string,
    id: string,) => {




  return `/api/v1/users/${ownerEmail}/cars/${id}/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const usersCarsPartialUpdate = async (ownerEmail: string,
    id: string,
    patchedCarRequest?: PatchedCarRequest, options?: RequestInit): Promise<usersCarsPartialUpdateResponse> => {

  return customFetch<usersCarsPartialUpdateResponse>(getUsersCarsPartialUpdateUrl(ownerEmail,id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedCarRequest)
  }
);}


export type usersCarsDestroyResponse204 = {
  data: void
  status: 204
}

export type usersCarsDestroyResponseSuccess = (usersCarsDestroyResponse204) & {
  headers: Headers;
};
;

export type usersCarsDestroyResponse = (usersCarsDestroyResponseSuccess)

export const getUsersCarsDestroyUrl = (ownerEmail: string,
    id: string,) => {




  return `/api/v1/users/${ownerEmail}/cars/${id}/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const usersCarsDestroy = async (ownerEmail: string,
    id: string, options?: RequestInit): Promise<usersCarsDestroyResponse> => {

  return customFetch<usersCarsDestroyResponse>(getUsersCarsDestroyUrl(ownerEmail,id),
  {
    ...options,
    method: 'DELETE'


  }
);}


export type usersCarsCertificatesListResponse200 = {
  data: CertificateBasic[]
  status: 200
}

export type usersCarsCertificatesListResponseSuccess = (usersCarsCertificatesListResponse200) & {
  headers: Headers;
};
;

export type usersCarsCertificatesListResponse = (usersCarsCertificatesListResponseSuccess)

export const getUsersCarsCertificatesListUrl = (ownerEmail: string,
    id: string,
    params?: UsersCarsCertificatesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/users/${ownerEmail}/cars/${id}/certificates/?${stringifiedParams}` : `/api/v1/users/${ownerEmail}/cars/${id}/certificates/`
}

/**
 * Get basic certificate information for a specific car.
 * URL: /api/v1/cars/{car_id}/certificates/
 */
export const usersCarsCertificatesList = async (ownerEmail: string,
    id: string,
    params?: UsersCarsCertificatesListParams, options?: RequestInit): Promise<usersCarsCertificatesListResponse> => {

  return customFetch<usersCarsCertificatesListResponse>(getUsersCarsCertificatesListUrl(ownerEmail,id,params),
  {
    ...options,
    method: 'GET'


  }
);}


export type usersCarsComplianceDocumentsListResponse200 = {
  data: CarComplianceDocument[]
  status: 200
}

export type usersCarsComplianceDocumentsListResponseSuccess = (usersCarsComplianceDocumentsListResponse200) & {
  headers: Headers;
};
;

export type usersCarsComplianceDocumentsListResponse = (usersCarsComplianceDocumentsListResponseSuccess)

export const getUsersCarsComplianceDocumentsListUrl = (ownerEmail: string,
    id: string,
    params?: UsersCarsComplianceDocumentsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/users/${ownerEmail}/cars/${id}/compliance_documents/?${stringifiedParams}` : `/api/v1/users/${ownerEmail}/cars/${id}/compliance_documents/`
}

/**
 * Get compliance documents (certificates, inspection reports, violations,
 * and contracts) for a specific car.
 * URL: /api/v1/cars/{car_id}/compliance_documents/
 */
export const usersCarsComplianceDocumentsList = async (ownerEmail: string,
    id: string,
    params?: UsersCarsComplianceDocumentsListParams, options?: RequestInit): Promise<usersCarsComplianceDocumentsListResponse> => {

  return customFetch<usersCarsComplianceDocumentsListResponse>(getUsersCarsComplianceDocumentsListUrl(ownerEmail,id,params),
  {
    ...options,
    method: 'GET'


  }
);}


export type usersCarsHistoryListResponse200 = {
  data: CarHistoryEvent[]
  status: 200
}

export type usersCarsHistoryListResponseSuccess = (usersCarsHistoryListResponse200) & {
  headers: Headers;
};
;

export type usersCarsHistoryListResponse = (usersCarsHistoryListResponseSuccess)

export const getUsersCarsHistoryListUrl = (ownerEmail: string,
    id: string,
    params?: UsersCarsHistoryListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/users/${ownerEmail}/cars/${id}/history/?${stringifiedParams}` : `/api/v1/users/${ownerEmail}/cars/${id}/history/`
}

/**
 * Asset history: every record tagged to this car as a normalized,
 * date-sorted timeline (invoices, proposals, credits, tickets, violations,
 * inspection reports, certificates, and the governing contracts).
 *
 * URL: /api/v1/cars/{car_id}/history/
 * Optional ``?type=`` narrows which record types are returned. Access is
 * scoped by ``get_object`` (404 if the car is not visible to the caller),
 * so every sub-query is already limited to a car the caller may see.
 */
export const usersCarsHistoryList = async (ownerEmail: string,
    id: string,
    params?: UsersCarsHistoryListParams, options?: RequestInit): Promise<usersCarsHistoryListResponse> => {

  return customFetch<usersCarsHistoryListResponse>(getUsersCarsHistoryListUrl(ownerEmail,id,params),
  {
    ...options,
    method: 'GET'


  }
);}


export type usersCarsViolationsRetrieveResponse200 = {
  data: CarViolationsResponse
  status: 200
}

export type usersCarsViolationsRetrieveResponseSuccess = (usersCarsViolationsRetrieveResponse200) & {
  headers: Headers;
};
;

export type usersCarsViolationsRetrieveResponse = (usersCarsViolationsRetrieveResponseSuccess)

export const getUsersCarsViolationsRetrieveUrl = (ownerEmail: string,
    id: string,) => {




  return `/api/v1/users/${ownerEmail}/cars/${id}/violations/`
}

/**
 * Get basic violation information for a specific car.
 * URL: /api/v1/cars/{car_id}/violations/
 */
export const usersCarsViolationsRetrieve = async (ownerEmail: string,
    id: string, options?: RequestInit): Promise<usersCarsViolationsRetrieveResponse> => {

  return customFetch<usersCarsViolationsRetrieveResponse>(getUsersCarsViolationsRetrieveUrl(ownerEmail,id),
  {
    ...options,
    method: 'GET'


  }
);}


export type usersCarsAggregateRetrieveResponse200 = {
  data: AggregateResult
  status: 200
}

export type usersCarsAggregateRetrieveResponseSuccess = (usersCarsAggregateRetrieveResponse200) & {
  headers: Headers;
};
;

export type usersCarsAggregateRetrieveResponse = (usersCarsAggregateRetrieveResponseSuccess)

export const getUsersCarsAggregateRetrieveUrl = (ownerEmail: string,
    params: UsersCarsAggregateRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/users/${ownerEmail}/cars/aggregate/?${stringifiedParams}` : `/api/v1/users/${ownerEmail}/cars/aggregate/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const usersCarsAggregateRetrieve = async (ownerEmail: string,
    params: UsersCarsAggregateRetrieveParams, options?: RequestInit): Promise<usersCarsAggregateRetrieveResponse> => {

  return customFetch<usersCarsAggregateRetrieveResponse>(getUsersCarsAggregateRetrieveUrl(ownerEmail,params),
  {
    ...options,
    method: 'GET'


  }
);}


export type usersCarsFormListResponse200 = {
  data: CarForm[]
  status: 200
}

export type usersCarsFormListResponseSuccess = (usersCarsFormListResponse200) & {
  headers: Headers;
};
;

export type usersCarsFormListResponse = (usersCarsFormListResponseSuccess)

export const getUsersCarsFormListUrl = (ownerEmail: string,
    params?: UsersCarsFormListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/users/${ownerEmail}/cars/form/?${stringifiedParams}` : `/api/v1/users/${ownerEmail}/cars/form/`
}

/**
 * Trimmed CarForm list for form dropdowns (SDK: carsFormList).
 *
 * Separate endpoint so the generated type is the precise CarForm shape;
 * the old ``?variant=form`` query param can't be typed per-value in OpenAPI.
 * Honors the same filters as the default list (e.g. property/portfolio).
 */
export const usersCarsFormList = async (ownerEmail: string,
    params?: UsersCarsFormListParams, options?: RequestInit): Promise<usersCarsFormListResponse> => {

  return customFetch<usersCarsFormListResponse>(getUsersCarsFormListUrl(ownerEmail,params),
  {
    ...options,
    method: 'GET'


  }
);}


export type usersCarsKpisByPropertyIdListResponse200 = {
  data: CarInProperty[]
  status: 200
}

export type usersCarsKpisByPropertyIdListResponseSuccess = (usersCarsKpisByPropertyIdListResponse200) & {
  headers: Headers;
};
;

export type usersCarsKpisByPropertyIdListResponse = (usersCarsKpisByPropertyIdListResponseSuccess)

export const getUsersCarsKpisByPropertyIdListUrl = (ownerEmail: string,
    propertyId: string,
    params?: UsersCarsKpisByPropertyIdListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/users/${ownerEmail}/cars/kpis-by-property-id/${propertyId}/?${stringifiedParams}` : `/api/v1/users/${ownerEmail}/cars/kpis-by-property-id/${propertyId}/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const usersCarsKpisByPropertyIdList = async (ownerEmail: string,
    propertyId: string,
    params?: UsersCarsKpisByPropertyIdListParams, options?: RequestInit): Promise<usersCarsKpisByPropertyIdListResponse> => {

  return customFetch<usersCarsKpisByPropertyIdListResponse>(getUsersCarsKpisByPropertyIdListUrl(ownerEmail,propertyId,params),
  {
    ...options,
    method: 'GET'


  }
);}


export type usersCarsMissedMaintenanceRetrieveResponse200 = {
  data: Car
  status: 200
}

export type usersCarsMissedMaintenanceRetrieveResponseSuccess = (usersCarsMissedMaintenanceRetrieveResponse200) & {
  headers: Headers;
};
;

export type usersCarsMissedMaintenanceRetrieveResponse = (usersCarsMissedMaintenanceRetrieveResponseSuccess)

export const getUsersCarsMissedMaintenanceRetrieveUrl = (ownerEmail: string,) => {




  return `/api/v1/users/${ownerEmail}/cars/missed-maintenance/`
}

/**
 * List cars whose maintenance completion fell below the threshold
 * for the given month.
 */
export const usersCarsMissedMaintenanceRetrieve = async (ownerEmail: string, options?: RequestInit): Promise<usersCarsMissedMaintenanceRetrieveResponse> => {

  return customFetch<usersCarsMissedMaintenanceRetrieveResponse>(getUsersCarsMissedMaintenanceRetrieveUrl(ownerEmail),
  {
    ...options,
    method: 'GET'


  }
);}


export type usersCheckPermissionCreateResponse200 = {
  data: CheckPermissionResponse
  status: 200
}

export type usersCheckPermissionCreateResponseSuccess = (usersCheckPermissionCreateResponse200) & {
  headers: Headers;
};
;

export type usersCheckPermissionCreateResponse = (usersCheckPermissionCreateResponseSuccess)

export const getUsersCheckPermissionCreateUrl = () => {




  return `/api/v1/users/check-permission/`
}

/**
 * Check if a user has permission to access a specific resource. Without this annotation drf-spectacular guesses the viewset's UserDetail serializer for the request/response, which is wrong.
 */
export const usersCheckPermissionCreate = async (checkPermissionRequest: CheckPermissionRequest, options?: RequestInit): Promise<usersCheckPermissionCreateResponse> => {

  return customFetch<usersCheckPermissionCreateResponse>(getUsersCheckPermissionCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(checkPermissionRequest)
  }
);}


export type usersSendSpendingNotificationCreateResponse200 = {
  data: UsersSendSpendingNotificationCreate200
  status: 200
}

export type usersSendSpendingNotificationCreateResponseSuccess = (usersSendSpendingNotificationCreateResponse200) & {
  headers: Headers;
};
;

export type usersSendSpendingNotificationCreateResponse = (usersSendSpendingNotificationCreateResponseSuccess)

export const getUsersSendSpendingNotificationCreateUrl = () => {




  return `/api/v1/users/send-spending-notification/`
}

/**
 * Email a client a spending notification for an invoice/proposal. Without this annotation drf-spectacular guesses the viewset's UserDetail serializer for the request body, which is wrong.
 */
export const usersSendSpendingNotificationCreate = async (spendingNotificationRequest: SpendingNotificationRequest, options?: RequestInit): Promise<usersSendSpendingNotificationCreateResponse> => {

  return customFetch<usersSendSpendingNotificationCreateResponse>(getUsersSendSpendingNotificationCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(spendingNotificationRequest)
  }
);}


